module.exports = __webpack_public_path__ + "media/7.33434cf8.mp3";